import type { GachaEvmPurchase } from "@anaconda/core/gacha/evm-purchase"
import { action, atom, computed } from "@reatom/core"

function needsDeliveryCheck(record: GachaEvmPurchase) {
  return (
    record.active &&
    Boolean(record.reportedHash || record.evidence) &&
    ["payment_pending", "paid", "fulfilling"].includes(record.state)
  )
}

export function createGachaEvmDeliveryTracking(
  getRecords: () => GachaEvmPurchase[],
  name: string,
) {
  const checks = atom<Record<string, { remaining: number; expiresAt: number }>>(
    {},
    `${name}.checks`,
  )
  const track = action((record: GachaEvmPurchase) => {
    if (!needsDeliveryCheck(record) || checks()[record.id]) return
    checks.set((current) => ({
      ...current,
      [record.id]: { remaining: 20, expiresAt: Date.now() + 120_000 },
    }))
  }, `${name}.track`)
  const pending = computed(
    () =>
      getRecords().filter(
        (record) =>
          needsDeliveryCheck(record) &&
          (checks()[record.id]?.remaining ?? 0) > 0,
      ),
    `${name}.pending`,
  )
  const take = action((id: string) => {
    const check = checks()[id]
    if (!check || check.remaining === 0) return false
    const expired = Date.now() >= check.expiresAt
    checks.set((current) => ({
      ...current,
      [id]: { ...check, remaining: expired ? 0 : check.remaining - 1 },
    }))
    return !expired
  }, `${name}.take`)
  return { track, pending, take }
}
